import { toBoolean } from 'pages/utils/sanitize';

import { SerializedItem } from './types';

export const checkForActiveSerials = (serials: SerializedItem[]) =>
  serials.filter((serial) => !toBoolean(serial.isRefunded));

export const getAllSelectedSerials = (serials: SerializedItem[]) =>
  serials.filter((serial) => serial.isSelected);
